import styled from "styled-components";

export const CarDetailsWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 15px #00000040;
  width: 420px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 28px 20px;
  height: 100%;
  overflow: auto;
  .checkbox-wrapper {
    padding: 0px 20px;
    margin-bottom: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    color: #1d1d1d;
  }
  .close-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 16px;
  }
  @media (max-width: 550px) {
    width: 100%;
  }
`;
export const SpeakerSetting = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 4px !important;
    p{
    width:40%;
    }
    .select{
    width:79%;
    }
`;
export const TableInnerSection = styled.div`
  width: 100%;
  height: calc(100vh - 158px);

  .super-time-theme--cell {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--text-primary);
    opacity: 0.5;
    font-weight: 500;
  }
  .action-btn {
    .round-btn {
      border-color: var(--border-color);
      color: var(--text-primary);
    }
  }
  .table-btn-wrapper {
    padding: 0;
    flex-wrap: nowrap;
  }
  .delete-icon {
    cursor: pointer;
    margin-left: 45px;
  }
  @media (max-width: 850px) {
    height: calc(100vh - 248px);
    .MuiCheckbox-root {
      padding: 9px 3px;
    }
    .action-btn {
      span {
        display: none;
      }
      .table-btn-wrapper {
        .round-btn {
          min-height: 21px;
          border-radius: 21px;
        }

        > .delete-icon {
          margin: 0;
        }
      }
    }
    .MuiDataGrid-row {
      position: relative;
      min-height: 78px !important;
      padding-bottom: 28px;
      > div {
        :nth-child(2) {
          position: absolute;
          overflow: unset !important;
          min-height: fit-content !important;
          bottom: 6px;
          right: 0;
          max-width: max-content !important;
        }
        :nth-child(4) {
          max-width: 100% !important;
          flex: 1 !important;
          width: 100% !important;
          overflow: unset !important;
          white-space: normal !important;
        }
        :nth-child(5) {
          width: 84px !important;
          max-width: 84px !important;
        }
        :nth-child(6) {
          width: 70px !important;
          max-width: 70px !important;
        }
        :last-child {
          position: absolute;
          overflow: unset !important;
          min-height: fit-content !important;
          bottom: 6px;
          left: 22px;
        }
      }
    }
    .MuiDataGrid-columnHeader.lastcolumnSeparator.display,
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator.display {
      display: none;
    }
    .MuiDataGrid-columnHeadersInner {
      flex: 1;
      > div {
        > div {
          :nth-child(4) {
            max-width: 100% !important;
            flex: 1 !important;
            width: 100% !important;
            overflow: unset !important;
            white-space: normal !important;
          }
          :nth-child(5) {
            width: 84px !important;
            max-width: 84px !important;
          }
          :nth-child(6) {
            width: 70px !important;
            max-width: 70px !important;
          }
        }
      }
    }
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator.text-column {
      max-width: 100% !important;
      flex: 1;
    }
    .MuiDataGrid-columnHeadersInner {
      > div {
        width: 100%;
      }
    }
    .MuiDataGrid-columnHeaderTitle {
      font-size: 12px;
    }
    /* .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator {
      max-width: 100% !important;
      width: 100% !important;
    } */
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  .header-text {
    flex: 1;
    svg {
      cursor: pointer;
    }
    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      h4 {
        color: #000;
        font-weight: 400;
        font-size: 22px;
        line-height: 150.5%;
      }
    }
  }
  .header-icons-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      height: 35px;
      width: 35px;
      background: #4c4a4a;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const CarType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 13px;
  .big-car {
    position: relative;
    left: 10px;
  }
  .battery-status {
    position: absolute;
    left: 0;
    top: 0;
    .persent {
      display: flex;
      align-items: center;
      gap: 7px;
    }
    p {
      font-size: 16px;
      line-height: 23px;
      color: #1d1d1d;
    }
    span {
      font-size: 13px;
      line-height: 23px;
    }
  }
  .change-car {
    width: 208px;
  }
  .edit-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    margin-bottom: 18px;
    svg {
      cursor: pointer;
    }
    p {
      font-size: 18px;
      line-height: 23px;
      color: #000000;
    }
    .max-hole-exceeded {
      font-size: 14px;
      color: #ffffff;
      background: #fa3c30;
      border-radius: 10px;
      min-width: 300px;
      width: 100%;
      text-align: center;
      font-weight: 500;
    }
    .action-zone-alert {
      display: list-item;
      color: #fa3c30;
    }
  }

  @media (max-width: 850px) {
    > svg {
      width: 150px;
      margin-top: 15px;
    }
  }
`;
export const HoleSpeedWrapper = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #f3ede4 0%, #ffffff 100%);
  border-radius: 6px;
  button {
    border: none;
    flex: 1;
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0;
    justify-content: center;
    gap: 4px;
    background-color: transparent;
    border-right: 1px solid #0000001a;
  }
  .flag {
    color: #947550;
  }
  .time {
    color: #f0ad00;
  }
  .yds {
    border: none;
    span {
      color: #ffffff;
      background: #000000;
      border-radius: 5px;
      font-size: 12px;
      line-height: 15px;
      padding: 4px 5px;
    }
  }
`;

export const Players = styled.ul`
  padding: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;

  > li {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 19px;
    gap: 22px;
    padding: 16px 14px;
    border-bottom: 1px dashed #0000004d;
    :last-child {
      border: none;
    }

    input {
      font-size: 16px;
      border: none;
      outline: none;
      width: 100%;
    }
  }
`;

export const SoftwareUpdate = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 20px;
  background: #ffebb7;
  border: 1px solid #eacc7f;
  border-radius: 6px;
  margin-bottom: 16px;
  width: 100%;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  cursor: pointer;
  p {
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }
  span {
    color: #1d1d1d;
    font-size: 12px;
    line-height: 14px;
  }
`;
export const ItemWrapper = styled.div`
  display: block;
  .icon {
    float: right;
  }
`;
export const FleetCarLegend = styled.div`
  background: #ffffff;

  &.map-legend {
    .modal-body {
      .first-section {
        gap: 25px 7px;
      }
      ul {
        li {
          margin-bottom: 0;
        }
      }
    }
  }
  .mt-48 {
    margin-top: 48px;
  }
  .modal-header {
    min-height: 56px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    background-color: #fff;
    position: relative;
    border-radius: 10px;
    .close-icon {
      background: transparent;
      border: none;
      padding: 0;
      position: absolute;
      top: -9px;
      right: -9px;
    }
    h2 {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 22px;
      line-height: 150.5%;
      color: #1d1d1d;
    }
  }
  .modal-body {
    background: linear-gradient(180deg, #f3ede4 0%, #ffffff 38.22%);
    padding: 30px 39px 10px;
    max-height: 564px;
    overflow: auto;
    .first-section {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 15px 0;
    }
    .number-icon {
      background: #ffffff;
      border: 1px solid #e7e8d4;
      width: 20px;
      height: 20px;
      color: #000000;
      font-size: 10px;
      line-height: 12px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      &.red {
        background: #f01100;
        border: 1px solid #e7e8d4;
        color: #ffffff;
      }
    }
    @media (max-width: 850px) {
      max-height: 400px;
    }
    ul {
      max-width: 199px;
      min-width: 199px;
      li {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        gap: 9px;
        font-family: "Roboto";
        min-height: 30px;
        font-family: "Roboto";
        font-size: 13px;
        line-height: 15px;
        span {
          display: flex;
          min-width: 20px;
          align-items: center;
          justify-content: center;
        }
        :first-child,
        &.li-sub-heading {
          font-family: "Roboto";
          font-weight: 600;
          font-size: 13px;
          line-height: 15px;
          /* padding-bottom: 11px; */
        }
        &.li-main-heading {
          font-weight: 600;
          font-size: 16px;
          line-height: 35px;
          margin: 0;
          padding: 0rem;
          min-height: 35px;
        }
      }
    }
    .alerts-icon-wrapper {
      li {
        gap: 6.5px;

        :nth-child(3) {
          span {
            background: #ffedc0;
            border-color: #fa6c30;
          }
        }
        :nth-child(4) {
          span {
            background: #ffabab;
            border-color: #ffabab;
            color: #fff;
          }
        }
        :nth-child(5) {
          span {
            background: #efe4d7;
            border-color: #e7cfb4;
          }
        }
        :nth-child(6) {
          span {
            background: gray;
            border-color: gray;
          }
        }
      }
      span {
        min-width: 40px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        gap: 4.7px;
        justify-content: center;
        background: #ff0000;
        border-left: 2.4px solid #ff0000;
        font-size: 13px;
        line-height: 14px;
        padding: 0 3px;
      }
    }
  }
`;

export const DeregisterCarButton = styled.button`
  padding: 13px 20px;
  background: transparent;
  border: 1px solid #acacac;
  border-radius: 6px;
  margin-bottom: 16px;
  width: 100%;
  font-size: 16px;
  line-height: 19px;
  &.active {
    background: #ffebb7;
    border: 1px solid #eacc7f;
  }
`;
